import React from 'react'

import {
  Button,
  Fieldset,
  HeadContent,
  Loading,
  Pagination,
  Subsection,
  Table,
} from '@fourthwall/components'

import { usePostTagsContext } from './hooks/usePostTagsContext'
import { PostTagsProvider } from './providers/PostTagsProvider'

const PostTagsContent = () => {
  const { table, pagination, openPostTagModal, isFetching, isLoading } = usePostTagsContext()

  return (
    <>
      <HeadContent title="Post tags" />
      <Subsection title="Post tags">
        <Fieldset>
          <Fieldset.Row>
            Add tags to posts that members can use to find content they are interested in.
          </Fieldset.Row>
          <Fieldset.Row>
            <Button
              label="Create tag"
              appearance="primary"
              size="small"
              onClick={openPostTagModal}
            />
          </Fieldset.Row>
          <Fieldset.Row>
            {isFetching ? (
              <Loading isLoading />
            ) : (
              <div style={{ width: '100%' }}>
                <Table {...table} isLoading={isLoading} />
              </div>
            )}
          </Fieldset.Row>
          {pagination.pageCount !== 1 && (
            <Fieldset.Row>
              <div style={{ width: '100%' }}>
                <Pagination {...pagination} />
              </div>
            </Fieldset.Row>
          )}
        </Fieldset>
      </Subsection>
    </>
  )
}

export const PostTags = () => (
  <PostTagsProvider>
    <PostTagsContent />
  </PostTagsProvider>
)
